import React from 'react'
import { IoMdArrowRoundBack } from "react-icons/io";
import useQRScanner from '../useQRScanner';
import {
    BarcodeScanner,
} from '@capacitor-mlkit/barcode-scanning';

export default function ForCameraOpen() {
    const { endScanQr } = useQRScanner()
    const stopScan = async () => {
        // Make all elements in the WebView visible again
        document.querySelector('body')?.classList.remove('barcode-scanner-active');

        // Remove all listeners
        await BarcodeScanner.removeAllListeners();

        // Stop the barcode scanner
        await BarcodeScanner.stopScan();
    };
    return (
        <div className='bg-transparent h-screen w-screen'>
            <div className='flex justify-between'>
                <span className='ps-3 pt-4 flex'>
                    <img
                        alt="Doctora OPD"
                        src="/assets/images/logo.png"
                        className="h-9"
                    />
                </span>
                <div className='pe-3 pt-4'>
                    <button onClick={() => {stopScan(); endScanQr(); }} className='btn-blue w-12'><div className='flex items-center justify-center gap-1'><IoMdArrowRoundBack className='w-4 h-4' /><span>Close</span></div></button>
                </div>
            </div>
            <div className='h-full content-center -mt-[100px] pt-28 justify-items-center'>
                <div className='flex justify-center items-center h-1/2 w-10/12 sm:w-1/2'>
                    <div className='m-8 h-full w-full border-l-4 border-red-500 flex flex-col justify-between items-start'>
                        <div className='border-t-4 border-red-500 w-full'>
                            <span></span>
                        </div>
                        <div className='border-b-4 border-red-500 w-full'>
                            <span></span>
                        </div>
                    </div>
                    <div className='m-8 h-full w-full border-r-4 border-red-500 flex flex-col justify-between items-end'>
                        <div className='border-t-4 border-red-500 w-full'>
                            <span></span>
                        </div>
                        <div className='border-b-4 border-red-500 w-full'>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div className='text-green-600'>
                    Scan QR code to visit doctor's profile
                </div>
            </div>
        </div>
    )
}
